import "bootstrap/dist/js/bootstrap.bundle.js";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/@fortawesome/fontawesome-free/js/all";
import "../src/assets/sass/app.scss";
import "primeicons/primeicons.css";
import "primevue/resources/primevue.min.css";
import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import i18n from "./utils/i18n";
import VueCookies from "vue-cookies";
import { store } from './store'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import PrimeVue from "primevue/config";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import ToastService from "primevue/toastservice";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import Paginator from "primevue/paginator";
import RadioButton from 'primevue/radiobutton';
import Toast from 'primevue/toast';
import Tooltip from 'primevue/tooltip';
import Calendar from 'primevue/calendar';
import Menu from 'primevue/menu';
import Checkbox from 'primevue/checkbox';
import Tag from 'primevue/tag';
import MultiSelect from 'primevue/multiselect';
import InputMask from 'primevue/inputmask';
import ConfirmationService from 'primevue/confirmationservice';
import Dialog from 'primevue/dialog';
import ConfirmDialog from 'primevue/confirmdialog';
import AutoComplete from 'primevue/autocomplete';
import Slider from 'primevue/slider';
import InputSwitch from 'primevue/inputswitch';
import Password from 'primevue/password';
import Carousel from 'primevue/carousel';
import NavbarVue from "./components/Navbar/Navbar.vue"
import FooterSchedule from "./components/FooterSchedule/FooterSchedule.vue"
import ButtonVue from './components/Button/Button.vue'
import CardField from './components/CardField/CardField.vue'
import Header from './components/Header/Header.vue'
import ModalVue from "./components/Modal/Modal.vue";
import CheckboxWeekDaysVue from "./components/Form/CheckboxWeekDays.vue";
import ToggleButton from "./components/ToggleButton/ToggleButton.vue"
import CalendarVue from "./components/Calendar/Calendar.vue"

const app = createApp(App)

app.use(ToastService);
app.component('DataTable', DataTable)
app.component("Column", Column)
app.component("ColumnGroup", ColumnGroup)
app.component("InputText", InputText)
app.component("InputNumber", InputNumber)
app.component("Dropdown", Dropdown)
app.component("Paginator", Paginator)
app.component("RadioButton", RadioButton)
app.component("Toast", Toast)
app.component("Calendar", Calendar)
app.component("Menu", Menu)
app.component("Checkbox", Checkbox)
app.component("Tag", Tag)
app.component("MultiSelect", MultiSelect)
app.component("InputMask", InputMask)
const dialogProps = (Dialog as any).props;
dialogProps.draggable.default = false;

app.component("Dialog", Dialog)
app.component("ConfirmDialog", ConfirmDialog)
app.component("AutoComplete", AutoComplete)
app.component("Slider", Slider)
app.component("InputSwitch", InputSwitch)
app.component("Password", Password)
app.component("Carousel", Carousel)
app.directive('tooltip', Tooltip);
app.use(ConfirmationService);

app.component('ds-button', ButtonVue)
app.component('ds-navbar', NavbarVue)
app.component('ds-card-field', CardField)
app.component('ds-header', Header)
app.component('ds-modal', ModalVue)
app.component('checkbox-week-days', CheckboxWeekDaysVue)
app.component('ds-toggle-button', ToggleButton)
app.component('FooterSchedule', FooterSchedule)
app.component('ds-calendar', CalendarVue)

app.use(VueCookies)
app.use(i18n)
app.use(store)
app.use(router)
app.use(PrimeVue, {
     locale: {
        "dayNames": ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
        "monthNames": ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
        "dayNamesShort": ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        "dayNamesMin": ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
        "monthNamesShort": ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
        "accept":"Sim",
        "reject":"Não",
    }
})
app.use(ToastService)
app.mount('#app')